(() => {
    /**
     * This code loads the content from on page components and updates the JSON-LD
     * generated by the server side JS in <head> tag. In https://www.gtlaw.com.au/_admin/?screen=contents&assetid=104
     */
    addEventListener('DOMContentLoaded', () => {
        const formatText = (text) => {
            // remove new lines and double spaces and '"'
            return text
                .replace(/\r\n|\r|\n|\t/g, ' ')
                .replace(/\s{2,}/g, ' ')
                .replace(/"/g, '\\"');
        };

        const jsonLd = document.getElementById('profileJsonLd');

        if (!jsonLd) {
            return;
        }

        const bio = document.querySelector('.profile-biography__content');
        const awards = document.querySelector('.awards-block__list');
        const experience = document.querySelector('.profile-experience__content');

        if (bio) {
            const experienceText = experience ? formatText(experience.innerText) : '';
            const description = `${formatText(bio.innerText)} ${experienceText}`.trim();
            const updated = jsonLd.innerHTML.replace('__DESCRIPTION_PLACEHOLDER__', description);
            jsonLd.innerHTML = updated;
        }

        if (awards) {
            const list = [];
            for (const item of awards.children) {
                list.push(formatText(item.children[0].innerText));
            }

            const awardsList = list.join(', ');
            const updated = jsonLd.innerHTML.replace('__AWARDS_PLACEHOLDER__', awardsList);
            jsonLd.innerHTML = updated;
        } else {
            const updated = jsonLd.innerHTML.replace('__AWARDS_PLACEHOLDER__', '');
            jsonLd.innerHTML = updated;
        }
    });
})();
